export default {
      id: "clock-usage",
      viewBox: "0 0 12 12",
      url: __webpack_public_path__ + "img/icons.31feac93.svg#clock",
      toString: function () {
        return this.url;
      }
    }